import React, { useState, useEffect } from "react";
import { getReferences } from "../../services/vu";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const Language = props => {

  const [languages, setLanguages] = useState([])

  useEffect(()=>{
    getReferences().then(({ languageCodesList }) => {
        setLanguages(languageCodesList)
    });
  },[])

  return (
    languages.length && (
      <FormControl variant="standard" fullWidth>
        <InputLabel error={!!props.errors}>Language</InputLabel>
        <Select
          name={props.name}
          placeholder="Language"
          value={props.value || ""}
          onChange={props.onChange}
        >
          {languages.length &&
            languages.map((language) => (
              <MenuItem
                key={language.languageCode}
                value={language.languageCode}
              >
                {language.description}
              </MenuItem>
            ))}
        </Select>
        {!!props.errors ? (
          <FormHelperText error>{props.errors}</FormHelperText>
        ) : null}
      </FormControl>
    )
  );
}
export default Language;